module.exports = __webpack_public_path__ + "img/appstore.04203de2.png";